var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clientContentWrap"},[_c('h4',{staticClass:"subTitle"},[_vm._v("의뢰 내용")]),_vm._v(" "),_c('div',{staticClass:"clientContent"},[_c('textarea',{ref:"content",on:{"input":_vm.updateContent}},[_vm._v(_vm._s(this.content_))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-373d5ad6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/ContactUs/ClientContent.vue
// module id = null
// module chunks = 